<template>
  <svg class="timeline" width="2" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="1" y1="0" x2="1" y2="100%" stroke="url(#gradient)" stroke-opacity="0.3" stroke-width="2" stroke-dasharray="8 8"/>
    <defs>
      <linearGradient x1="1" y1="0" x2="1" y2="100%" id="gradient" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="white" stop-opacity="0"/>
        <stop offset="0.0572917" stop-color="white" stop-opacity="1"/>
        <stop offset="0.932292" stop-color="white" stop-opacity="1"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'Timeline',
  };
</script>

<style lang="scss">
  .timeline {
    height: 100%;
    display: block;
  }
</style>
